import { useEffect, useState } from 'react';
import { createContainer } from 'react-tracked';
import { useAccount } from 'wagmi';
import { useBackendApi } from '../helpers/backendHelper';
import { identifyUser, limitedApi } from '../utils';

const useGlobal = () => {
  const [state, setState] = useState({});
  const { isConnecting, isConnected } = useAccount();
  const [userLoading, setUserLoading] = useState(true);
  const [authDisabled, setAuthDisabled] = useState(false);
  const backendApi = useBackendApi();

  const setValue = (key, value) => setState(state => ({ ...state, [key]: value }));
  const setUser = user => setValue('user', user);

  const logout = () => {
    setValue('user', null);
    window.dispatchEvent(new Event('logout'));
  };

  const getAllProtocols = async () => {
    try {
      const allProtocols = await backendApi.mrep.getAllProtocols();
      setValue('protocolMapping', allProtocols?.data);
    } catch (error) {
      console.log('Error in loading protocols list', error);
      setValue('protocolMapping', {});
    }
  };

  const getAllChains = async () => {
    try {
      const allProtocols = await backendApi.mrep.getAllChains();
      setValue('chainMapping', allProtocols?.data);
    } catch (error) {
      console.log('Error in loading protocols list', error);
      setValue('chainMapping', {});
    }
  };

  useEffect(() => {
    getAllProtocols();
    getAllChains();
  }, []);

  useEffect(() => {
    if (state?.user || state?.user === null) {
      return setUserLoading(false);
    }
    if (isConnecting) return;
    if (!isConnected) {
      setUserLoading(false);
      if (state.user !== null) {
        setValue('user', null);
      }
      return;
    }

    limitedApi('user', () =>
      backendApi
        .refreshAccessToken()
        .then(response => {
          setValue('user', response.data);
          setAuthDisabled(false);
        })
        .catch(e => {
          console.error(e);
          setValue('user', null);
        })
        .finally(() => {
          setUserLoading(false);
        }),
    );
  }, [isConnected, isConnecting]);

  useEffect(() => {
    if (state?.user) {
      backendApi.reviews
        .protocolAdmins()
        .then(response => {
          setValue('protocolAdmin', new Set([...(response?.data || [])]));
        })
        .catch(e => {
          console.log('Error in getting protocol Admin', e);
          setValue('protocolAdmin', new Set([]));
        });

      identifyUser(state?.user?.address);
    }
  }, [state?.user]);

  const testToggle = () => {
    setState(s => ({ ...s, r: Math.random() }));
  };

  return [{ ...state, setUser, logout, testToggle, userLoading, setValue, authDisabled, setAuthDisabled }, setState];
};

const { Provider, useTracked } = createContainer(() => useGlobal());

export const useGlobalState = useTracked;
export const GlobalStateProvider = ({ children }) => <Provider>{children}</Provider>;
export default GlobalStateProvider;
